import {
  Control,
  useWatch,
  UseFormSetValue,
  FieldValues,
  Path,
} from 'react-hook-form';

interface UseSmtpIntegrationReturn {
  smtpValue: any;
  onSmtpChange: (value: any) => void;
}

export const useSmtpIntegration = <T extends FieldValues>(
  control: Control<T>,
  setValue: UseFormSetValue<T>,
): UseSmtpIntegrationReturn => {
  const smtpIntegrationId = useWatch({
    control,
    name: 'smtpIntegrationId' as Path<T>,
  });

  return {
    smtpValue: smtpIntegrationId,
    onSmtpChange: (value: any) => {
      setValue('smtpIntegrationId' as Path<T>, value);
    },
  };
};
